var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 987.03 155.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#212121;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.28,2.74c12.17,0,20.28,8.11,20.28,20.28V72.91L87.21,11.46c4.46-5.88,10.14-8.72,17-8.72,12.17,0,20.28,8.11,20.28,20.28V132.74c0,12.17-8.11,20.28-20.28,20.28S84,144.91,84,132.74V82.65L38.33,142.88c-5.07,6.69-11.15,10.14-18,10.14C8.11,153,0,144.91,0,132.74V23C0,10.85,8.11,2.74,20.28,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.63,132.74c0,12.17-8.11,20.28-20.28,20.28s-20.28-8.11-20.28-20.28V94.41h-43.4v38.33c0,12.17-8.11,20.28-20.28,20.28s-20.28-8.11-20.28-20.28V23c0-12.17,8.11-20.28,20.28-20.28S207.67,10.85,207.67,23V57.9h43.4V23c0-12.17,8.11-20.28,20.28-20.28S291.63,10.85,291.63,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.67,41.07a37,37,0,0,0-36.91,37.11,36.69,36.69,0,0,0,36.91,36.91,40.25,40.25,0,0,0,30-12.57c8.31-8.92,19.87-8.92,28.59-.2s8.93,20.08.21,29c-13.8,14.6-35.5,24.34-58.82,24.34-21.29,0-39.55-7.51-54.76-22.72S333.2,99.48,333.2,78.18s7.5-39.54,22.71-54.75S389.38.51,410.67.51c23.53,0,45.23,10.34,59.22,25.76,8.32,8.92,8.32,20.28-.4,28.59s-20.69,8.32-28.8-.61C432.78,45.53,422.84,41.07,410.67,41.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.92,77.37l38.74,40.77c8.31,8.92,8.11,20.48-.82,28.8s-20.48,8.11-28.79-.82l-39.75-42v28.6c0,12.17-8.12,20.28-20.28,20.28s-20.28-8.11-20.28-20.28V23c0-12.17,8.11-20.28,20.28-20.28S557.3,10.85,557.3,23V50.4L596.64,9.64c8.72-8.72,20.08-8.72,28.8-.41s8.92,20.08.61,28.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.21,2.74H939c13.59,0,25.15,4.87,34.28,14.6C982.36,26.88,987,39.85,987,55.88c0,17.64-4.46,31.43-13.59,41S953,111.24,939,111.24H904.49v21.5c0,12.17-8.12,20.28-20.28,20.28s-20.29-8.11-20.29-20.28V23C863.92,10.85,872,2.74,884.21,2.74Zm20.28,72h24.33c10.75,0,17.65-5.88,17.65-17.85,0-10.55-7.1-17.64-17.65-17.64H904.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.98,
    cy: 77.01,
    r: 77.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 745.8,
    cy: 77.03,
    r: 74.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728.94,5.14a74.14,74.14,0,0,1,8.33-1.45c.4,0,.81-.1,1.2-.13A73.84,73.84,0,0,1,813.27,107c-.16.37-.32.72-.51,1.09h0a73.73,73.73,0,0,1-39.12,37.32c-.88.35-1.75.69-2.64,1a74.08,74.08,0,0,1-25,4.45h0c-.87,0-1.74,0-2.6,0a74,74,0,0,1-55.82-28.4c-.26-.33-.52-.66-.77-1A73.87,73.87,0,0,1,728.94,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M786.86,125.11l-16.29-16.18S781,93,783.36,79.06l24.48-2.2a50,50,0,0,1,1.59,29S797.71,119.86,786.86,125.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M722,133.85l-28.28-14L691,91.14s20.75-3,26.84-5.47c0,0,13.77,20.53,20.82,26.58C738.64,112.25,731.48,127.06,722,133.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M763.34,51.46l-31.79,3.91L716.17,30.64a64.91,64.91,0,0,1,24.17-17.75s24.73,7.74,30.12,12.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.75,31.42l2.45,4.85.39.79c-.15.16-.31.32-.46.5h0c-5.38,6-10,19.57-11.22,23.52-.23.7-.34,1.09-.34,1.09h-.64l-4.45-.06A73.65,73.65,0,0,1,687.75,31.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791.54,19.09A73.47,73.47,0,0,1,814.11,49l-1.22,2.42-1.12,2.23-.15-.32h0c-1.15-2.56-9-19.21-20-27.37l-.06-.05V24.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M694.11,93.75l-.64.28c-.77-.15-11.48-10.12-15.73-32.74l1.17-.22c4.26,22.59,14.82,31.77,14.92,31.83l-.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M718.33,29.74l.11,1.18c-14.23,1.29-29.85,7.19-30,7.25L688,37.06C688.16,37,703.93,31,718.33,29.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733,54.48A83.35,83.35,0,0,0,718.35,90l-1.18-.19a84.56,84.56,0,0,1,14.87-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M773.13,108.94c-.2.07-20.2,6.76-36,4.23l.19-1.18c15.48,2.49,35.2-4.11,35.4-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M722,132.17s.29.41.85,1.07c2.36,2.84,9.73,10.78,23.13,17.64-.87,0-1.74,0-2.6,0-12.8-7-19.72-14.71-21.73-17.18-.4-.49-.6-.78-.62-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M695.64,118.39l.39,1.13-1.75.61-6.72,2.31c-.26-.33-.52-.66-.77-1l6.88-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M787.17,123.23l1.11.45c-.12.31-.25.61-.39.91-3.84,8.91-10,16.34-14.24,20.83-.88.35-1.75.69-2.64,1,4-4,11.12-11.87,15.5-21.66C786.74,124.26,787,123.74,787.17,123.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M807.94,105.27l1.51.5,3.82,1.23c-.16.37-.32.72-.51,1.09l-4.1-1.33-1.09-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M812.77,49.11c1,8.74-4.83,29.29-5.08,30.17L806.55,79c.06-.21,6-21.2,5-29.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M784.58,79.94l-1.11.42c-.07-.18-7.16-18.52-20.88-29.18l.73-.94C777.3,61.1,784.51,79.75,784.58,79.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M792.86,25l-.32,1.15c-9.79-2.78-24.61.64-24.76.67l-.27-1.16C768.13,25.56,782.79,22.18,792.86,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M737.27,3.69c.4,0,.81-.09,1.21-.11L741.22,14l-.58.15,0,0-.55.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.46759718128f6d4e1139255a530f0ab2.svg";
export { ForwardRef as ReactComponent };